<template>
  <v-container fluid>
    <v-row v-if="loadingPersonalData" align="center" justify="center" style="min-height: 60vh">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="text-h5 mt-4">Cargando información del personal...</div>
      </v-col>
    </v-row>

    <v-row v-else-if="!personal" align="center" justify="center" style="min-height: 60vh">
      <v-col cols="12" class="text-center">
        <v-icon color="error" size="80">mdi-account-alert</v-icon>
        <h2 class="mt-2">No se encontró información de personal</h2>
        <TextButton color="secondary" class="mt-4" @click="loadPersonal">
          <v-icon left>mdi-refresh</v-icon>
          Reintentar
        </TextButton>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="4">
        <TextButton text class="mx-2" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon> Volver a catálogo de personal
        </TextButton>
      </v-col>
      <v-col cols="8" align="right">
        <v-spacer></v-spacer>
        <TextButton
          rounded
          color="secondary"
          class="mx-2"
          v-if="personal.foto && personal.foto.length > 0"
          @click="download(personal.foto)"
        >
          Descargar fotografía
        </TextButton>
      </v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="12">
            <PersonalCardComponent />
          </v-col>
          <v-col cols="12">
            <MenuListComponent :estatus="personal.fk_idEstatus" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="9">
        <component :is="currentComponent" v-bind="componentProps" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { MENU_EXPEDIENTE_PERSONAL } from '../../menuExpedientePersonal'
import PersonalCardComponent from '../../components/expediente/PersonalCardComponent.vue'
import MenuListComponent from '../../components/expediente/MenuListComponent.vue'
import DatosGeneralesComponent from '../../components/expediente/DatosGeneralesComponent.vue'
import DocumentosTabContent from '../../components/expediente/datos-generales/tab-content/DocumentosTabContent.vue'
import TramitesAdministrativosTabContent from '../../components/expediente/datos-generales/tab-content/TramitesAdministrativosTabContent.vue'
import LineaTiempoTabContent from '../../components/expediente/datos-generales/tab-content/LineaTiempoTabContent.vue'
import DesarrolloElemento from '../../components/expediente/DesarrolloElemento.vue'
import MediaFiliacionComponent from '../../components/expediente/MediaFiliacionComponent.vue'
import EvaluacionesComponent from '../../components/expediente/EvaluacionesComponent.vue'
import CarreraPolicialComponent from '../../components/expediente/CarreraPolicialComponent.vue'
import TrayectoriaLaboralComponent from '../../components/expediente/TrayectoriaLaboralComponent.vue'
import LocsPersonalMainContainer from '../../components/expediente/locs/LocsPersonalMainContainer.vue'
import TextButton from '../../components/base/TextButton.vue'
import ReferenciasComponent from '@src/components/expediente/ReferenciasComponent.vue'
import PuestoDependenciaComponent from '@src/components/expediente/PuestoDependenciaComponent.vue'
import ResultadosC3Section from '@src/components/expediente/ResultadosC3Section.vue'

export default {
  components: {
    PersonalCardComponent,
    MenuListComponent,
    DatosGeneralesComponent,
    ReferenciasComponent,
    DocumentosTabContent,
    TramitesAdministrativosTabContent,
    PuestoDependenciaComponent,
    LineaTiempoTabContent,
    ResultadosC3Section,
    DesarrolloElemento,
    MediaFiliacionComponent,
    EvaluacionesComponent,
    CarreraPolicialComponent,
    TrayectoriaLaboralComponent,
    LocsPersonalMainContainer,
    TextButton,
  },

  data() {
    return {
      loadingPersonalData: false,
      MENU: MENU_EXPEDIENTE_PERSONAL,
    }
  },

  computed: {
    ...mapGetters('personal', { personal: 'getPersonalSingle' }),
    ...mapGetters('expediente', { selectedMenu: 'getSelectedMenu' }),

    currentComponent() {
      const componentMap = {
        [this.MENU.DATOS_GENERALES]: 'DatosGeneralesComponent',
        [this.MENU.REFERENCIAS]: 'ReferenciasComponent',
        [this.MENU.DOCUMENTOS]: 'DocumentosTabContent',
        [this.MENU.DESARROLLO_ELEMENTO]: 'DesarrolloElemento',
        [this.MENU.TRAMITES_ADMINISTRATIVOS]: 'TramitesAdministrativosTabContent',
        [this.MENU.PUESTO_DEPENDENCIA]: 'PuestoDependenciaComponent',
        [this.MENU.RESULTADOS_C3]: 'ResultadosC3Section',
        [this.MENU.LINEA_TIEMPO]: 'LineaTiempoTabContent',
        [this.MENU.MEDIA_FILIACION]: 'MediaFiliacionComponent',
        [this.MENU.EVALUACIONES]: 'EvaluacionesComponent',
        [this.MENU.CARRERA_POLICIAL]: 'CarreraPolicialComponent',
        [this.MENU.TRAYECTORIA_LABORAL]: 'TrayectoriaLaboralComponent',
        [this.MENU.LOCS]: 'LocsPersonalMainContainer',
      }

      return componentMap[this.selectedMenu] ?? 'DatosGeneralesComponent'
    },

    componentProps() {
      const props = {}

      if (this.selectedMenu === this.MENU.REFERENCIAS) {
        props.personal = this.personal
      }

      if (this.selectedMenu === this.MENU.DESARROLLO_ELEMENTO) {
        props.estatus = this.personal?.fk_idEstatus
        props.idPersonal = this.personal?.idPersonal
      }

      if (this.selectedMenu === this.MENU.PUESTO_DEPENDENCIA) {
        props.personal = this.personal
      }

      if (this.selectedMenu === this.MENU.RESULTADOS_C3) {
        props.personal = this.personal
      }

      if (this.selectedMenu === this.MENU.CARRERA_POLICIAL) {
        props.personal = this.personal
      }

      if (this.selectedMenu === this.MENU.TRAYECTORIA_LABORAL || this.selectedMenu === this.MENU.LOCS) {
        props.idPersonal = this.personal?.idPersonal
      }

      return props
    },
  },

  async mounted() {
    this.SET_SELECTED_MENU(MENU_EXPEDIENTE_PERSONAL.DATOS_GENERALES)
    await this.loadPersonal()
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),

    download(url) {
      window.open(url, '_blank')
    },

    async loadPersonal() {
      this.loadingPersonalData = true
      const id = Number(this.$route.params.id)
      if (id) {
        await this.fetchPersonalById(id)
      }
      this.loadingPersonalData = false
    },
  },
}
</script>
